import React from "react";

interface Props {
  /** e.g. "patients", "diagnosis visits", "bills" */
  metricLabel: string;
  threshold: number;
  current: number;
}

// Shown in place of a chart when there isn't enough data yet to draw a
// meaningful trend — distinct from LockedFeatureEmptyState, which is for
// plan-gating rather than data-volume gating.
export const NotEnoughDataEmptyState: React.FC<Props> = ({ metricLabel, threshold, current }) => (
  <div className="flex flex-col items-center justify-center py-10 sm:py-16 px-4 sm:px-6 text-center">
    <div className="mb-4 sm:mb-5 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-slate-100 flex items-center justify-center">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18" />
        <path d="M7 16v-3M12 16V9M17 16v-6" />
      </svg>
    </div>
    <p className="text-sm font-semibold text-slate-800">Not enough data yet</p>
    <p className="text-xs text-slate-500 mt-1 max-w-sm">
      This needs at least {threshold} {metricLabel} in the selected range to show a meaningful trend — you currently have {current}. Check back once you have more, or widen the date range.
    </p>
  </div>
);

export default NotEnoughDataEmptyState;
